import { type FC } from 'react'

import './_userCard.scss'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import * as spriteIcons from 'assets/svg/sprite'
import { toFixedNumber } from 'helpers/dataTransformations'
import { Icons } from 'helpers/icons'
import { TransactionType } from 'types/enums/TransactionType'

import AvatarHolder from '../AvatarHolder/AvatarHolder'

const productToType = {
    post: 'post',
    'add deposit': 'deposit',
    'tipp model': 'tip',
    'tipp post': 'tip',
    'tipp story': 'tip',
    'tipp stream': 'tip',
    subscription: 'subscription',
    message: 'message',
    refund: 'refund',
    chargebacks: 'chargeback'
}

const UserCardTransactions: FC<{
    transaction: any
}> = ({ transaction }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleOpenProfile = () => {
        if (!transaction.username) return

        navigate(`/${transaction.username}`)
    }

    return (
        <div className='userCard userCard__transactions'>
            <div className='userCard__transactions__content'>
                <div className='userCard__transactions__content--left'>
                <div
                    className='userCard__avatar'
                    onClick={handleOpenProfile}
                    style={{ cursor: 'pointer' }}
                >
                    <AvatarHolder
                        img={transaction.avatar}
                        size='80'
                        userId={transaction.userId}
                        username={transaction.username}
                    />
                </div>
                    <div className='userCard__info'>
                        <p className='userCard__info__name'>
                            {transaction.name}
                        </p>
                        <p className='userCard__info__username'>
                            @{transaction.username}
                        </p>
                        <p
                            className={`userCard__info__type userCard__info__type__${
                                productToType[
                                    transaction.product as keyof typeof productToType
                                ]
                            }`}
                        >
                            {t(
                                productToType[
                                    transaction.product as keyof typeof productToType
                                ]
                            )}
                        </p>
                    </div>
                </div>
                <div className='userCard__transactions__content--right'>
                    <div className='userCard__values'>
                        <div className='userCard__values__amount'>
                            {transaction.error && (
                                <spriteIcons.IconProcessingError />
                            )}
                            <PriceWrapper>
                                <div className='chargeback'>
                                    {transaction?.chargebacks === 1 ? (
                                        <span>!</span>
                                    ) : (
                                        ''
                                    )}
                                    <p className='userCard__values__amount--price'>
                                        ${toFixedNumber(transaction.amount, 2)}
                                    </p>
                                </div>
                                {transaction.type === TransactionType.CARD && (
                                    <img
                                        src={Icons.transactionCard}
                                        alt={t('paymentCard')}
                                    />
                                )}
                                {transaction.type ===
                                    TransactionType.WALLET && (
                                    <img
                                        src={Icons.transactionWallet}
                                        alt={t('wallet')}
                                    />
                                )}
                            </PriceWrapper>
                        </div>
                        {transaction.error && (
                            <p className='userCard__values__amount--error'>
                                {t('couldNotProcess')}
                            </p>
                        )}
                        <p className='userCard__values__date'>
                            {dayjs(transaction.date).format('lll')}
                        </p>
                        <p className='userCard__values__order'>
                            {t('orderId')}: {transaction.orderId}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserCardTransactions

const PriceWrapper = styled.div`
    display: flex;
    gap: 1rem;
`
